import config from '../../config';
import { HTTP } from  '../../http';
import moment from 'moment';
import _ from "lodash";

const pageSize = 50
const moneyoutUri = config.apiEndpoints.moneyOutUri
const withDrawalsUri = config.apiEndpoints.withdrawalsUri
const billPaymentUri = config.apiEndpoints.billPaymentUri
const bankTransferUri = config.apiEndpoints.bankTransferUri
const pixTransferUri = config.apiEndpoints.pixTransferUri
//const paymentProviderUri =  'http://localhost:13750/api/moneyouts/'
//const paymentProviderConfigUri = 'http://localhost:13750/api/paymentproviders/' 
const paymentProviderUri =  'https://api-moneyflows.sepag.app.br/api/moneyouts/'
const paymentProviderConfigUri = 'https://api-moneyflows.sepag.app.br/api/paymentproviders/'
const moneyOutStatuses = [
    {id: "PENDING", name: "Pendente"},
    {id: "ANALYSIS", name: "Em análise"},
    {id: "PROCESSING", name: "Processando"},
    {id: "DONE", name: "Finalizado"},
    {id: "CANCELED", name: "Cancelado"},
]
const moneyOutType = [
    {id: "WITHDRAW", name: "Saque"},
    {id: "BANKTRANSFER", name: "Transferência"},
    {id: "PIXTRANSFER", name: "Pix"},
]

export default {
    findAll: (request, page) => {
        request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endedDate = request.endedDate == '' ?  '' : moment(request.endedDate).format('YYYY-MM-DDTHH:mm:ss')
        request.scheduledDate = request.scheduledDate == '' ?  '' : moment(request.scheduledDate).format('YYYY-MM-DDTHH:mm:ss')
        return new Promise((resolve, reject) => {            
            HTTP.get(`${moneyoutUri}search?keywords=${request.keywords}&status=${request.status}&pageSize=${pageSize}&page=${page}&salespersonid=${request.salesPersonId}&sellerId=${request.sellerId}&scheduledDate=${request.scheduledDate}&startDate=${request.startDate}&endDate=${request.endDate}&moneyoutgroupid=${request.moneyOutGroupId}`)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAllExport: (request) => {
        request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endedDate = request.endedDate == '' ?  '' : moment(request.endedDate).format('YYYY-MM-DDTHH:mm:ss')
        request.scheduledDate = request.scheduledDate == '' ?  '' : moment(request.scheduledDate).format('YYYY-MM-DDTHH:mm:ss')
        return new Promise((resolve, reject) => {            
            HTTP.get(`${moneyoutUri}search/export?keywords=${request.keywords}&status=${request.status}&salespersonid=${request.salesPersonId}&sellerId=${request.sellerId}&scheduledDate=${request.scheduledDate}&startDate=${request.startDate}&endDate=${request.endDate}&moneyoutgroupid=${request.moneyOutGroupId}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {                
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        })
    },
    summary: (request) => {
        request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format('YYYY-MM-DDTHH:mm:ss')
        request.endedDate = request.endedDate == '' ?  '' : moment(request.endedDate).format('YYYY-MM-DDTHH:mm:ss')
        request.scheduledDate = request.scheduledDate == '' ?  '' : moment(request.scheduledDate).format('YYYY-MM-DDTHH:mm:ss')
        return new Promise((resolve, reject) => {            
            HTTP.get(`${moneyoutUri}summary?keywords=${request.keywords}&status=${request.status}&salespersonid=${request.salesPersonId}&sellerId=${request.sellerId}&scheduledDate=${request.scheduledDate}&startDate=${request.startDate}&endDate=${request.endDate}&moneyoutgroupid=${request.moneyOutGroupId}`)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getStatuses: () => {
        return _.clone(moneyOutStatuses);
    },
    getTypes: () => {
        return _.clone(moneyOutType);
    },
    createWithDraw: (entity) => {        
        return new Promise((resolve, reject) => {
            entity.scheduledDate = moment(entity.scheduledDate).format();
            HTTP.post(withDrawalsUri, entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createBankTransfer: (entity) => {
        return new Promise((resolve, reject) => {
            entity.scheduledDate = moment(entity.scheduledDate).format();
            HTTP.post(bankTransferUri, entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createPixTransfer: (entity) => {
        return new Promise((resolve, reject) => {
            entity.scheduledDate = moment(entity.scheduledDate).format();
            HTTP.post(pixTransferUri, entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createBillPayment: (entity) => {
        return new Promise((resolve, reject) => {
            entity.scheduledDate = moment(entity.scheduledDate).format();
            HTTP.post(billPaymentUri, entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    updateStatus: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.put(`${moneyoutUri}${request.id}/status/`, { status: request.status }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findWithDraw: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(withDrawalsUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findBillPayment: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(billPaymentUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findBankTransfer: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(bankTransferUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findPixTransfer: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(pixTransferUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getBlockedAmount: (customerId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(moneyoutUri.concat(`blockedamount?customerId=${customerId}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getPaymentProviderBalance: () =>{
        return new Promise((resolve, reject) => {
            HTTP.get(paymentProviderUri.concat(`payment-provider-balance`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getPaymentProviderConfig: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(paymentProviderConfigUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    savePaymentProviderConfig: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(paymentProviderConfigUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getPaymentStatus: (id, isTransfer) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(paymentProviderUri.concat(isTransfer ? `payment-transfer-status?id=${id}` : `billet-payment-status?id=${id}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getBilletInfo: (barcode) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(paymentProviderUri.concat(`billet-payment-info?barcode=${barcode}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    makePayment: (entity) => {
        return new Promise((resolve, reject) => {
            HTTP.post(paymentProviderUri.concat(`make-payment`), entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    saveAttachments: (model) => {        
        return new Promise((resolve, reject) => {
            HTTP.put(moneyoutUri.concat(`${model.id}/receipts`), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}